import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.function.name";

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import AvApi from './api';
import API_OPTIONS from './options';

var AvMicroservice =
/*#__PURE__*/
function (_AvApi) {
  _inheritsLoose(AvMicroservice, _AvApi);

  function AvMicroservice(_ref) {
    var _this;

    var http = _ref.http,
        promise = _ref.promise,
        merge = _ref.merge,
        config = _ref.config;
    _this = _AvApi.call(this, {
      http: http,
      promise: promise,
      merge: merge,
      config: config
    }) || this;
    _this.defaultConfig = _this.merge({}, API_OPTIONS.MS, config);
    return _this;
  } // override aries 1 url concatenation


  var _proto = AvMicroservice.prototype;

  _proto.getUrl = function getUrl(config, id) {
    if (id === void 0) {
      id = '';
    }

    var _this$config = this.config(config),
        path = _this$config.path,
        version = _this$config.version,
        name = _this$config.name,
        configId = _this$config.id;

    var parts = [path, version || '', name];

    if (id || configId) {
      parts = [path, version || '', name, id || configId];
    }

    return parts.join('/').replace(/[/]+/g, '/').replace(/\/$/, '');
  } // polling location is the same url
  ;

  _proto.getLocation = function getLocation(response) {
    return this.getUrl(response.config);
  };

  return AvMicroservice;
}(AvApi);

export { AvMicroservice as default };